import React from "react";
import { Link } from "react-router-dom";
import Logo from "../images/hemsida Logo.png";

export default function Navbar() {
  return (
    <>
      <nav className="navbar navbar-expand-sm">
        <div className="container-fluid">
          {/* Logo on the left */}
          <a className="navbar-brand" href="#">
            <img src={Logo} width={100} alt="Logo" />
          </a>

          {/* Collapse button on the right */}
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#collapsibleNavbar"
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          {/* Navbar items in the center */}
          <div
            className="collapse navbar-collapse justify-content-center"
            id="collapsibleNavbar"
          >
            <ul className="navbar-nav">
              <li className="nav-item">
                <Link to="/">Home</Link>
              </li>
              <li className="nav-item">
                <Link to="/Contact">Contact</Link>
              </li>
              <li className="nav-item">
                <Link to="/About">About</Link>
              </li>
              <li className="nav-item">
                <Link to="/Projects">Projects</Link>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </>
  );
}
